
import { Link } from 'react-router-dom';

interface GuideSectionProps {
  region: string;
  title: string;
  description: string;
  highlights: string[];
  imageUrl: string;
  reverse?: boolean;
}

export default function GuideSection({ region, title, description, highlights, imageUrl, reverse = false }: GuideSectionProps) {
  return (
    <section className="py-16 bg-dark-900">
      <div className="container mx-auto px-4 sm:px-6">
        <div className={`grid lg:grid-cols-2 gap-12 items-center max-w-7xl mx-auto ${reverse ? 'lg:grid-flow-col-dense' : ''}`}>
          {/* Content */}
          <div className={`space-y-6 ${reverse ? 'lg:col-start-2' : ''}`}>
            <div className="space-y-4">
              <div className="inline-flex items-center px-4 py-2 bg-red-600/20 text-red-400 rounded-full text-sm font-medium">
                <i className="ri-map-pin-line mr-2"></i>
                {region}
              </div>
              <h2 className="text-3xl lg:text-4xl font-bold text-white">
                {title}
              </h2>
              <p className="text-lg text-gray-300 leading-relaxed">
                {description}
              </p>
            </div>

            {/* Highlights */}
            <div className="space-y-3">
              {highlights.map((highlight, index) => (
                <div key={index} className="flex items-start gap-3">
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className="ri-check-line text-red-400 text-lg"></i>
                  </div>
                  <span className="text-gray-300">{highlight}</span>
                </div>
              ))}
            </div>

            {/* CTA */}
            <div className="pt-6 space-y-4">
              <div className="text-sm text-gray-400">
                Ready to explore {region}? {' '}
                <Link to="/contact" className="text-red-400 hover:text-red-300 font-medium transition-colors duration-200">
                  Contact Tony Monteiro
                </Link>
                {' '}for personalized mortgage advice.
              </div>
            </div>

          </div>

          {/* Image */}
          <div className={`${reverse ? 'lg:col-start-1' : ''}`}>
            <div className="relative">
              <div className="aspect-[4/3] rounded-2xl overflow-hidden bg-dark-800 border border-dark-700">
                <img 
                  src={imageUrl}
                  alt={`${region} neighbourhood guide`}
                  className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-300"
                />
              </div>
              <div className="absolute -bottom-4 -right-4 bg-red-600 text-white px-4 py-2 rounded-full text-sm font-bold shadow-lg">
                <i className="ri-home-3-line mr-1"></i>
                {region}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
